import React from "react";
import "./UserCard.css";

const UserCard = ({ user, onCardClick }) => {
  return (
    <div className={user.active === "y" ? "usercard" : "usercard usercardinactive"} onClick={(e) => onCardClick(user)}>
      <div className='ucardheader'>
        <h2>{user.name + " " + user.lastname}</h2>
        <p style={{ textAlign: "right" }}>{user.active === "y" ? "Active" : "Disabled"}</p>
      </div>
      <div className='ucardbody'>
        <li>
          <p>UserID:</p>
          <p>{user.userID}</p>
        </li>
        <li>
          <p>User:</p>
          <p>{user.user}</p>
        </li>
        <li>
          <p>Role:</p>
          <p>{user.role}</p>
        </li>
      </div>
    </div>
  );
};

export default UserCard;
